import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_PersonPicker = _resolveComponent("PersonPicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SearchInput, {
      "model-value": _ctx.keyword,
      placeholder: "Search people...",
      class: "q-mb-sm",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.keyword = $event))
    }, null, 8, ["model-value"]),
    _createVNode(_component_PersonPicker, {
      ref: "picker",
      "client-id": _ctx.clientId,
      mode: "single",
      "model-value": _ctx.modelValue !== null ? [_ctx.modelValue] : [],
      keyword: _ctx.keyword,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event[0] || null)))
    }, null, 8, ["client-id", "model-value", "keyword"])
  ]))
}